const enableScroll = () => document.body.classList.remove('no_scroll');

export default enableScroll;
